import Vue from 'vue'
import './plugins'
import { router } from './router'
import store from './stores'
import Meta from 'vue-meta'
import Root from './root.vue'
import '@/assets/styles/_main.scss'
import '@/assets/styles/nprogress.css'

// Global components >>>
import '@/components/base'
import '@/components/typography'
// <<< Global components
Vue.use(Meta)

// Configure Vue to ignore Shopify App Bridge web components
// These are native custom elements provided by the App Bridge CDN script, not Vue components
Vue.config.ignoredElements = [
  's-page',      // Shopify Page component (title bar)
  's-button',    // Shopify Button component
  's-link'       // Shopify Link component
]

async function initApp (){

  const isMobile = () => (window.innerWidth <= 1045)

  store.commit('ui/SET_IS_MOBILE', { value: isMobile() })

  var resizeTimer;
  window.addEventListener('resize', (ev) => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      store.commit('ui/SET_IS_MOBILE', { value: isMobile() })
    }, 100)
  })


  const appInstance = new Vue({
    store,
    router,
    render:createElement => createElement(Root)
  })
    .$mount('#app')

  appInstance.$validator.localize('en')
}


initApp()



// WEBPACK FOOTER //
// ./src/index.js